import React from "react";
import { Badge } from '@/components/ui/badge';
import { Share2 } from 'lucide-react';

const UmpireProfileHeader = ({ umpire }) => {
  const handleShareProfile = () => {
    navigator.clipboard.writeText(window.location.href);
  };
  return (
    <div className="rounded-2xl shadow bg-white overflow-hidden">
      {/* Cover Image */}
      <div className="relative h-40 md:h-56 w-full bg-gradient-to-r from-green-700 to-yellow-400 flex items-center justify-center">
        {umpire.coverPhoto ? (
          <img src={umpire.coverPhoto} alt="Cover" className="w-full h-full object-cover" />
        ) : (
          <span className="text-5xl text-white opacity-30"> <Share2 className="w-16 h-16" /> </span>
        )}
        {/* Avatar Overlap */}
        <div className="absolute left-8 bottom-[-64px] md:left-16">
          {umpire.profilePhoto ? (
            <img src={umpire.profilePhoto} alt="Profile" className="w-32 h-32 object-cover rounded-full border-4 border-white shadow-lg bg-white" />
          ) : (
            <div className="w-32 h-32 rounded-full bg-gray-300 flex items-center justify-center text-5xl font-bold text-white border-4 border-white shadow-lg">
              {umpire.firstName?.[0] || '?'}
            </div>
          )}
        </div>
      </div>
      {/* Main Info Row */}
      <div className="pt-20 md:pt-24 px-8 pb-4 flex flex-col md:flex-row md:items-end md:justify-between">
        <div className="flex flex-col gap-2">
          <h1 className="text-4xl font-extrabold text-green-800 flex items-center gap-2">
            {umpire.firstName} {umpire.middleName} {umpire.lastName}
          </h1>
          <div className="flex flex-wrap gap-2">
            {umpire.panelType && <Badge>{umpire.panelType}</Badge>}
            {umpire.primaryRole && <Badge>{umpire.primaryRole}</Badge>}
            {umpire.status && <Badge>{umpire.status}</Badge>}
            {umpire.availabilityStatus && <Badge>{umpire.availabilityStatus}</Badge>}
          </div>
          {umpire.nationality && (
            <div className="mt-2 text-gray-600">{umpire.nationality}</div>
          )}
        </div>
        <button
          onClick={handleShareProfile}
          className="mt-4 md:mt-0 flex items-center gap-2 border border-green-700 text-green-700 px-4 py-2 rounded-lg hover:bg-green-700 hover:text-white transition-colors"
          title="Copy profile link"
        >
          <Share2 className="mr-2 h-5 w-5" /> Share Profile
        </button>
      </div>
    </div>
  );
};

export default UmpireProfileHeader; 